import { useState, useCallback } from "react";
import API_ROUTES from "./apiRoutes";

export const useTemplates = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  const getToken = () => localStorage.getItem("token");

  const resetStates = useCallback(() => {
    setLoading(false);
    setError(null);
    setSuccess(false);
  }, []);

  const fetchTemplates = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(API_ROUTES.TEMPLATES.list(), {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${getToken()}`,
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.message || "Erro ao buscar templates.");
      setTemplates(data.templates || data); // aceita array direto ou {templates: []}
      setSuccess(true);
    } catch (err) {
      setError(err.message || "Erro ao buscar templates.");
    } finally {
      setLoading(false);
    }
  }, []);

  const createTemplate = useCallback(async (templateData) => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(API_ROUTES.TEMPLATES.create(), {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${getToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(templateData),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.message || "Erro ao criar template.");
      await fetchTemplates();
      setSuccess(true);
    } catch (err) {
      setError(err.message || "Erro ao criar template.");
    } finally {
      setLoading(false);
    }
  }, [fetchTemplates]);

  const updateTemplate = useCallback(async (id, templateData) => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(API_ROUTES.TEMPLATES.update(id), {
        method: "PUT",
        headers: {
          "Authorization": `Bearer ${getToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(templateData),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.message || "Erro ao atualizar template.");
      await fetchTemplates();
      setSuccess(true);
    } catch (err) {
      setError(err.message || "Erro ao atualizar template.");
    } finally {
      setLoading(false);
    }
  }, [fetchTemplates]);

  const deleteTemplate = useCallback(async (id) => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(API_ROUTES.TEMPLATES.delete(id), {
        method: "DELETE",
        headers: {
          "Authorization": `Bearer ${getToken()}`,
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.message || "Erro ao deletar template.");
      await fetchTemplates();
      setSuccess(true);
    } catch (err) {
      setError(err.message || "Erro ao deletar template.");
    } finally {
      setLoading(false);
    }
  }, [fetchTemplates]);

  const setSelectedTemplateCallback = useCallback((template) => {
    setSelectedTemplate(template);
  }, []);

  return {
    templates,
    loading,
    error,
    success,
    selectedTemplate,
    setSelectedTemplate: setSelectedTemplateCallback,
    fetchTemplates,
    createTemplate,
    updateTemplate,
    deleteTemplate,
    resetStates,
  };
}; 